import { firestore } from "firebase";

export enum Collection {
    Users = "users",
    SamplingResults = "sampling_results",
    AnalysisResults = "analysis_results",
    Warranties = "Warranties",
    DeviceMasters = "DeviceMasters",
    adminTool = "adminTool"
}

export enum Role {
    Customer = 1,
    Admin = 2,
    Demo = 3
}

export interface User {
    role: Role,
    name: string
}

export interface SamplingResult {
    userRef: firestore.DocumentReference,
    samplingNo: string,
    samplingDateTime: firestore.Timestamp,
    samplingLatitude: number,
    samplingLongitude: number,
    samplingImage: string,
    comment: string,
    fieldName: string,
    cropName: string,
    soilTypeIndex: number,
    createDateTime: firestore.Timestamp,
    updateDateTime: firestore.Timestamp,
    deleteFlag: boolean
}

export interface AnalysisResult {
    userRef: firestore.DocumentReference,
    samplingResultRef: firestore.DocumentReference,
    scopeId: string,
    analysisId: number,
    analysisName: string,
    analysisPointX: number,
    analysisPointY: number,
    takenDateTime: firestore.Timestamp,
    analysisDateTime: firestore.Timestamp,
    dilutionRate: number,
    soilTypeIndex: number,
    absorbance1: number,
    absorbance2: number,
    absorbance3: number,
    absorbance4: number,
    absorbance5: number,
    absorbanceAvg: number,
    concentration1: number,
    concentration2: number,
    concentration3: number,
    concentration4: number,
    concentration5: number,
    concentrationAvg: number,
    concentrationValue: number,
    brayValue: number,
    truogValue: number,
    analysisImage: string,
    comment: string,
    createDateTime: firestore.Timestamp,
    updateDateTime: firestore.Timestamp,
    deleteFlag: boolean
}

export interface Warranty {
    ScopeRef: firestore.DocumentReference,
    SerialNo: string,
    BluetoothAddress: string,
    userRef: firestore.DocumentReference,
    userID: string,
    WarrantyStartDate: firestore.Timestamp,
    WarrantyFileName: string,
    CreateDateTime: firestore.Timestamp
}

export interface DeviceList {
    SerialNo: string,
    BluetoothAddress: string,
    Status: string,
    CreateDateTime: firestore.Timestamp
}

